import React, { useState } from 'react';
import Icon from '../../Icon';
import clsx from 'clsx';
import { translate } from '../../../Services/translation';

const DescriptionTabs = ({product, productFields, getIcon, getContent }) => {
  const [activeTab, setActiveTab] = useState(productFields[0]);

  const isCurrentTab = (id) => {
    return id == activeTab.groupId;
  };

  return (
    <div className="description-tabs">
      <div className="description-tabs__header-wrapper">
        <div className="description-tabs__header">
          {productFields.map((tab) => (
            <button
              className={clsx(
                'description-tab',
                isCurrentTab(tab.groupId) ? 'active' : ''
              )}
              key={`tab-${tab.groupId}`}
              onClick={() => setActiveTab(tab)}
              aria-label={translate(
                isCurrentTab(tab.groupId)
                  ? 'product.descriptiontab.active.sc'
                  : 'product.descriptiontab.inactive.sc'
              )}
            >
              <Icon
                name={getIcon(tab.groupId)}
                size={24}
                className="description-tab__icon"
              />
              <div className="description-tab__label">{tab.name}</div>
            </button>
          ))}
        </div>
      </div>

      <div className="description-tabs__content">
        {getContent(product, activeTab.groupId, activeTab.productFields)}
      </div>
    </div>
  );
};

export default DescriptionTabs;
